import {
  SwitchField as UadSwitchField,
  type SwitchProps as UadSwitchProps,
} from '@iconik-io/uad';

import { useFieldContext } from '../app_form_context';

export type SwitchFieldProps = Omit<
  UadSwitchProps,
  'name' | 'value' | 'isSelected' | 'onChange' | 'onBlur'
>;

export function SwitchField(props: SwitchFieldProps) {
  const field = useFieldContext<boolean>();

  return (
    <UadSwitchField
      name={field.name}
      value={field.name}
      isSelected={field.state.value}
      onChange={(value) => field.setValue(value)}
      onBlur={field.handleBlur}
      {...props}
    />
  );
}
